// import React, { useState } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { FiChevronDown } from 'react-icons/fi';
// import menuData from '../../assets/data/menu.json';
// import Icon from './Icon';
// import { useAuth } from '../../context/AuthContext';

// const Sidebar = ({ toggleSidebar }) => {
//     const { getUserRoles } = useAuth();
//     const userRoles = getUserRoles();

//     const location = useLocation();
//     const pathname = location.pathname;
//     const basePath = pathname.split('/').slice(0, 3).join('/') + '/';

//     const [showDropdownId, setShowDropdownId] = useState(null);
//     const setDropdownId = (id) => {
//         setShowDropdownId(prevId => (prevId === id ? null : id));
//     };

//     const hasAccess = (itemRoles) => {
//         return itemRoles.some(role => userRoles.includes(role));
//     };

//     return (
//         <div className={`layoutSidebar ${toggleSidebar ? 'hide' : ''}`}>
//             <Link to='/'>
//                 <div className='brand'>
//                     <img src='/images/logo.png' alt='Logo' />
//                 </div>
//             </Link>

//             <ul className='sidebarMenu'>
//                 {menuData && menuData.length > 0 && menuData.map(item => {
              
//                     if (!hasAccess(item.roles)) return null;

//                     const isActive = item.base_paths && item.base_paths.some(path => pathname.startsWith(path));

//                     if (item.submenu) {
//                         const filteredSubmenu = item.submenu.filter(subItem => hasAccess(subItem.roles));
//                         if (filteredSubmenu.length === 0) return null;

//                         return (
//                             <li key={item.label} className={`dropdownMenu ${showDropdownId === item.id || isActive ? 'opened' : ''}`}>
//                                 <div className='dropdownLabel'>
//                                     <Link to={`${item.link}`}>
//                                         <Icon icon={item.icon} /> <span>{item.label}</span>
//                                     </Link>
//                                     <button onClick={() => setDropdownId(item.id)}><FiChevronDown /></button>
//                                 </div>
//                                 <div className={`dropdownList ${showDropdownId === item.id || isActive ? 'show' : ''}`}>
//                                     <ul>
//                                         {filteredSubmenu.map(subItem => (
//                                             <li key={subItem.label} className={pathname === subItem.link ? 'active' : ''}>
//                                                 <Link to={subItem.link}>{subItem.label}</Link>
//                                             </li>
//                                         ))}
//                                     </ul>
//                                 </div>
//                             </li>
//                         );
//                     }

//                     return (
//                         <li key={item.label} className={pathname === item.link ? 'active' : ''}>
//                             <Link to={item.link}>
//                                 <Icon icon={item.icon} /><span>{item.label}</span>
//                             </Link>
//                         </li>
//                     );
//                 })}
//             </ul>
//         </div>
//     );
// };

// export default Sidebar;
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiChevronDown } from 'react-icons/fi';
import menuData from '../../assets/data/menu.json';
import Icon from './Icon';
import { useAuth } from '../../context/AuthContext';

const Sidebar = ({ toggleSidebar }) => {
    const { getUserRoles } = useAuth();
    const userRoles = getUserRoles();

    const location = useLocation();
    const pathname = location.pathname;
    const basePath = pathname.split('/').slice(0, 3).join('/') + '/';

    const [showDropdownId, setShowDropdownId] = useState(null);

    const setDropdownId = (id) => {
        setShowDropdownId(prevId => (prevId === id ? null : id));
    };

    // Allow access if:
    // - itemRoles is not provided
    // - itemRoles is an empty array
    // - OR user has any of the itemRoles
    const hasAccess = (itemRoles = []) => {
        return itemRoles.length === 0 || itemRoles.some(role => userRoles.includes(role));
    };

    return (
        <div className={`layoutSidebar ${toggleSidebar ? 'hide' : ''}`}>
            <Link to='/'>
                <div className='brand'>
                    <img src='/images/logo.png' alt='Logo' />
                </div>
            </Link>

            <ul className='sidebarMenu'>
                {menuData && menuData.length > 0 && menuData.map(item => {
                    if (!hasAccess(item.roles)) return null;

                    const isActive = item.base_paths && item.base_paths.some(path => pathname.startsWith(path));

                    // Handle items with submenu
                    if (item.submenu && item.submenu.length > 0) {
                        const filteredSubmenu = item.submenu.filter(subItem => hasAccess(subItem.roles));

                        // If no submenus are accessible, don't render the parent item
                        if (filteredSubmenu.length === 0) return null;

                        return (
                            <li key={item.label} className={`dropdownMenu ${showDropdownId === item.id || isActive ? 'opened' : ''}`}>
                                <div className='dropdownLabel'>
                                    <Link to={item.link}>
                                        <Icon icon={item.icon} />
                                        <span>{item.label}</span>
                                    </Link>
                                    <button onClick={() => setDropdownId(item.id)}><FiChevronDown /></button>
                                </div>
                                <div className={`dropdownList ${showDropdownId === item.id || isActive ? 'show' : ''}`}>
                                    <ul>
                                        {filteredSubmenu.map(subItem => (
                                            <li key={subItem.label} className={pathname === subItem.link ? 'active' : ''}>
                                                <Link to={subItem.link}>{subItem.label}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </li>
                        );
                    }

                    // Handle simple menu items without submenu
                    return (
                        <li key={item.label} className={pathname === item.link ? 'active' : ''}>
                            <Link to={item.link}>
                                <Icon icon={item.icon} />
                                <span>{item.label}</span>
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default Sidebar;
